<template>
    <div>
        <div class="topnav" :style="'background-color:'+$store.state.bgtop+';'">
           <img :src="logo1" style="" class="logo" alt="" >
           <div class="hright">
            <a  @click="$emit('hointop')" v-if="pmwidth>960">Home</a>
            <a  @click="$emit('hointop')" v-if="pmwidth<=960" class="el-icon-s-home"></a>
            <a  @click="$emit('toaboutlangsi')" v-if="pmwidth>960">About</a>
            <a  @click="$emit('toaboutlangsi')" v-if="pmwidth<=960" class="el-icon-user-solid"></a>
            <div class="c1"   @mouseleave="quit()" style="display:inline-block ;">
                <a @mouseenter="open_lock()" v-if="pmwidth>960">Smart Lock Series</a>
                <a  @mouseenter="open_lock()" v-if="pmwidth<=960" class="el-icon-lock"></a>
                <div v-if="open" class="bloom" ><smartlockseries class="xx" ></smartlockseries></div>
            </div>
            <div class="c2"   @mouseleave="quit()" style="display:inline-block ;">
            <a @mouseenter="open_camera()" v-if="pmwidth>960">Smart Camera Series</a>
            <a   @mouseenter="open_camera()" v-if="pmwidth<=960" class="el-icon-video-camera"></a>
            <div v-if="open2" class="bloom" ><smartcameraseries class="xx"></smartcameraseries></div>
        </div>
           
            <!-- <el-radio-group v-if="false" size="mini" v-model="language" style="margin-left: 20PX;">
            <el-radio-button label="ES"></el-radio-button>
            <el-radio-button label="POR"></el-radio-button>
            <el-radio-button label="EN"></el-radio-button>
            </el-radio-group> -->
           </div>
        </div>
        <!-- <div v-if="open" class="bloom" ><smartlockseries v-if="lock"></smartlockseries><smartcameraseries v-if="camera"></smartcameraseries></div> -->
        <!-- <div style="width: 100%;height: 100%;position: fixed;left: 0;top: 21rem;  z-index: 10000;" @mouseover="open=false;"></div> -->
    </div>
</template>
<script>
import logo1 from '../img/logo1.png'
import smartlockseries from '../components/smartlockseries.vue'
import smartcameraseries from '../components/smartcameraseries.vue'
export default {
  name: 'topnav',//头部导航
 
  data() {
    return {
        pmwidth:document.body.clientWidth,//屏幕宽度
        lock:false,//锁的商品框
        camera:false,//摄像头的商品框
        open:false,//下拉框的判断
        open2:false,
        language:"EN",
        logo1:logo1
    }
   },
   components: {
    smartlockseries,smartcameraseries
  },
  watch:{
    open2(newval){
      if(newval){
        this.open=false
      }
       
    },
    open(newval){
      if(newval){
        this.open2=false
      }
       
    }
  },
   methods:{
   quit(){
    this.lock=false;
    this.open=false;
    this.camera=false;
    this.open2=false;
   },
    open_camera(){
        this.open2=false
        let then=this
        then.open2=true
        this.lock=false
        
       then.camera=true
    },
    open_lock(){
        this.open=false
        let then=this
        then.open=true
        this.open=true
        this.camera=false
        then.lock=true
    }
   },
   mounted () {//实时监控屏幕宽度
    const that = this
    window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth
            that.pmwidth = window.screenWidth
        })()
    }
}
}
</script>
<style scoped>


.logo{
    width: 6rem; height: 3rem;margin-left: 14.5rem;
}
.hright a{
    font-size: 0.8rem;
    font-weight: bold;
    cursor: pointer;
    margin-top: 0px;
    margin-left: 3rem;
}
.hright a:hover{
    color: #1e9eb6;
}
.hright{
    float: right;
    margin-right: 6rem
    
}
.c1:hover{
    color: #1e9eb6; 
}
.c2:hover{
    color: #1e9eb6; 
}
@keyframes move{
    0%{
        height: 0px;
    }
    100%{
        height: 28rem; 
    }
}
@keyframes move2{
    0%{
        opacity:0
    }
    80%{
        opacity: 0;
    }
    100%{
        opacity:1
    }
}
.bloom .xx{
    width: 100%;
    height: 28rem; 
    
    position: fixed;
    left: 0;
    top: 3rem;
    animation:move2  1s;
}
.bloom{
    width: 100%;
    height: 28rem; 
    border-bottom: 1px solid #c8c8c8;
    background-color: rgba(0, 0, 0, 0.707);
    z-index: 10000;
    position: fixed;
    left: 0;
    top: 3rem;
    animation:move  1s;
}
.topnav{
    border-bottom: 1px solid #c8c8c8;
    width: 100%;
    height: 3rem;
    position: fixed;
    color: #fff;
    line-height: 3rem;
    top: 0;
    font-size: 0.5rem;
    left: 0;
    z-index: 10000;
    
}
@media screen and (max-width: 700px) {
    .bloom .xx{
    width: 100%;
    height: 28rem; 
    
    position: fixed;
    left: 0;
    top: 2rem;
    animation:move2  1s;
}
.bloom{
    width: 100%;
    height: 28rem; 
    border-bottom: 1px solid #c8c8c8;
    background-color: rgba(0, 0, 0, 0.707);
    z-index: 10000;
    position: fixed;
    left: 0;
    top: 2rem;
    animation:move  1s;
}
    .topnav{
    border-bottom: 1px solid #c8c8c8;
    width: 100%;
    height: 2rem;
    position: fixed;
    color: #fff;
    line-height: 3rem;
    top: 0;
    font-size: 0.5rem;
    left: 0;
    z-index: 10000;
    
}
    .logo{
    width: 3rem; height: 1.5rem;margin-left: 1rem;
}
    .hright a{
    font-size: 0.8rem;
    font-weight: bold;
    cursor: pointer;
    margin-top: 0px;
    margin-left: 1rem;
}
.hright a:hover{
    color: #1e9eb6;
}
.hright{
    float: right;
    margin-right: 1rem
    
}
.c1:hover{
    color: #1e9eb6; 
}
.c2:hover{
    color: #1e9eb6; 
}
}
</style>